<template>
    <div>
        <SeccionesComponent
            v-show="! zona"
            :recuperarSoloZonaAnexas="recuperarSoloZonaAnexas"
            :svgKey="svgKey"
            @terminar="zonaSeleccionada"
        />

        <transition name="fade" mode="out-in">
            <SeleccionarAsientosRegionNormal
                v-if="zona && ! zona.tiene_plazas"
                :asientos="asientos"
                :datos_compradores="datos_compradores"
                :zona="zona"
                @volver="volver"
                @asientosSeleccionados="asientosSeleccionados"
                :disabled="bloqueando || disabled"
            />

            <SeleccionarAsientosRegionAnexa 
                v-if="zona && zona.tiene_plazas"
                :zona="zona"
                :abonado="abonado"
                @asientosSeleccionados="asientosSeleccionados"
                :disabled="bloqueando || disabled"
                @volver="volver"
            />
        </transition>
    </div>
</template>

<script>
    import SeccionesComponent from './SeleccionarAsientoConSecciones/SeccionesComponent.vue';
    import SeleccionarAsientosRegionNormal from "./SeleccionarAsientosConRegiones/SeleccionarAsientosRegionNormal.vue";
    import SeleccionarAsientosRegionAnexa from "./SeleccionarAsientosConRegiones/SeleccionarAsientosRegionAnexa.vue";

    export default {
        props: {
            disabled: {
                required: true,
                type: Boolean
            },
            changeSeat: {
                required: true,
                type: Number
            },
            abonado: {
                required: false,
                type: Object,
                default: null
            },
            recuperarSoloZonaAnexas: {
                type: Boolean,
                default: false
            },
            bloquear: {
                required: false,
                type: Function,
                default: null
            }
        },
        data() {
            return {
                zona: null,
                asientos: [],
                datos_compradores: [],
                bloqueando: false,
                zonas_anexas: [],
                svgKey: 0
            }
        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            recinto() {
                return this.$store.getters.getRecinto;
            },
            renovacion() {
                return this.$route.query.n_abonado_antiguo != null;
            }
        },
        methods: {
            zonaSeleccionada(zona, zonas_anexas = []) {
                this.zona = zona;
                this.zonas_anexas = zonas_anexas || [];
            },
            volver() {
                if (this.renovacion && this.abonado && !this.recuperarSoloZonaAnexas) {
                    this.$router.push({ name: 'front.abonos.nuevo.index', query: { region_id: this.zona.id, dni: this.abonado.dni, n_abonado_antiguo: this.abonado.n_abonado_antiguo } });
                }

                this.asientos = [];
                this.datos_compradores = [];
                this.zona = null;
                this.svgKey++;
            },
            asientosSeleccionados(datos_compradores_temp, asientos_temp) {
                this.datos_compradores = datos_compradores_temp;
                this.asientos = asientos_temp;
                this.bloquearAsientos();
            },
            bloquearAsientos() {
                this.bloqueando = true;

                var seats = [];

                this.asientos.forEach(abonado => {
                    if(abonado.asiento) {
                        seats.push({
                            seat: abonado.asiento.asiento,
                            row: abonado.asiento.fila,
                            zona_id: abonado.asiento.zona_id,
                        });
                    }                
                });

                var plazas = [];

                this.asientos.forEach(asiento => {
                    if(asiento.plaza) {
                        plazas.push({
                            id: asiento.plaza.id,
                            region_id: this.zona.id,
                            abonado_id: this.abonado ? this.abonado.id : null
                        });
                    }
                });

                const esModoParking = this.recuperarSoloZonaAnexas;

                let params = {
                    butacas: plazas
                };

                if (esModoParking) {
                    params.filters = {
                        session_id: sessionStorage.getItem('session_id')
                    };
                } else {
                    params.filters = {
                        sesion_id: null
                    };
                    params.zona_id = this.zona.id;
                    params.asientos = seats;
                }

                const cookie = this.$cookies.get('comunicados-track-id');

                if(cookie) {
                    params.token_comunicado = cookie;
                }

                const fbp = this.$cookies.get("_fbp");
                const fbc = this.$cookies.get("_fbc");

                if (fbp && fbc){
                    params.fbp = fbp;
                    params.fbc = fbc;
                }

                const url = esModoParking ? 'front.bloquear.abonos-parking' : 'front.bloquear.asientos';

                // When a :bloquear prop is provided AND the call targets
                // bloquear-asientos, delegate to it. Otherwise fall back to
                // the legacy raw Vuex dispatch (used for parking + scope-out
                // paths to keep this PR surgical).
                const useProp = typeof this.bloquear === 'function' && url === 'front.bloquear.asientos';

                const dispatchPromise = useProp
                    ? Promise.resolve().then(() => this.bloquear(params))
                    : Promise.resolve(this.$store.dispatch(this.config.getVuexAlias(url), params));

                dispatchPromise.then(res => {
                    if(res.data.error) {
                        this.volver()
                        this.$toast.error('Butaca/s ocupada/s');
                    } else {
                        this.$emit('butacasBloqueadas', this.datos_compradores, this.asientos, this.zona, res.data.session_id, this.zonas_anexas)
                        sessionStorage.setItem('session_id', res.data.session_id);
                    }

                }).catch(error => {
                    if (error && error.message === 'IDENTIFICACION_INVALIDA') {
                        this.$emit('identificacion-invalida');
                    } else {
                        this.volver();
                        this.$toast.error('Butaca/s elegida/s por otro usuario.');
                    }
                }).finally(() => {
                    this.bloqueando = false;
                });
            },
            bloquearRenovacionSinAsientos(datos_compradores, asientos) {
                this.datos_compradores = datos_compradores;
                this.asientos = asientos;
                this.bloquearAsientos();
            },
        },
        components: {
            SeccionesComponent, SeleccionarAsientosRegionNormal, SeleccionarAsientosRegionAnexa
        }
    }
</script>